export default __webpack_public_path__ + "static/media/nodi.7fc3b217.webp";